const appConfig = {
    PRODUCT_OWL_URL: process.env.REACT_APP_OWL_SIGHT_URL || "#",
    PRODUCT_FALCON_URL: process.env.REACT_APP_FALCON_APP_URL || "#",
};

export default appConfig;
